export const BASE_URL = "http://localhost:3000/"
export const ASSETS_URL = process.env.REACT_APP_ASSETS_URL
export const CREDIT_API_URL = process.env.REACT_APP_CREDIT_SERVICE_API_BASE_URL || 'https://sandbox-api.growbizh.com/credit/'
export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_SERVICE_API_BASE_URL || 'https://sandbox-api.growbizh.com/admin/'
export const ADMIN_AUTH_TOKEN = process.env.REACT_APP_ADMIN_AUTH_TOKEN || ''